import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyOverrides, loadOverrides, onOverrides } from "../lib/siteCopy";

// Applies staff copy/image overrides to every public page and keeps them applied as React re-renders.
export default function SiteCopyApplier() {
  const { pathname } = useLocation();
  useEffect(() => {
    let raf = 0;
    const run = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => applyOverrides(document.body, pathname)); };
    loadOverrides().then(run);
    const off = onOverrides(run);
    const obs = new MutationObserver((muts) => { if (muts.some((m) => m.type === "childList" || (m.type === "characterData" && !m.target.parentElement?.closest("[data-copy-editor]")))) run(); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => { obs.disconnect(); off(); cancelAnimationFrame(raf); };
  }, [pathname]);
  return null;
}
